import { Box, Typography, Container, Paper } from "@mui/material";

function AgreementPage() {
  return (
    <Box sx={{ mt: 4 }}>
      <Container maxWidth="lg">
        <Typography textAlign="center" variant="h4" gutterBottom>
          Договор оферты
        </Typography>
        <Typography
          sx={{ mb: 5 }}
          color="text.secondary"
          textAlign="center"
          variant="body1"
          gutterBottom
        >
          Данное соглашение является офертой и определяет условия использования
        </Typography>

        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom>
            Пользовательское соглашение
          </Typography>
          <Typography paragraph>
            Добро пожаловать на <strong>Pay2Pay.org</strong>! Пожалуйста,
            внимательно ознакомьтесь с настоящим Пользовательским соглашением
            (далее — «Соглашение») перед использованием платформы. Используя
            нашу платформу, вы подтверждаете свое согласие с условиями данного
            Соглашения. Если вы не согласны с какими-либо из его положений, вам
            следует прекратить использование платформы.
          </Typography>

          <Typography variant="h6" gutterBottom>
            1. Общие положения
          </Typography>
          <Typography paragraph>
            1.1. Настоящее Соглашение регулирует отношения между владельцем
            платформы <strong>Pay2Pay.org</strong> (далее — «Платформа») и
            пользователем (физическим или юридическим лицом), зарегистрированным
            на платформе для оказания услуг по переводу средств (далее —
            «Пользователь»).
          </Typography>
          <Typography paragraph>
            1.2. Платформа предоставляет услуги по организации взаимодействия
            между участниками системы для выполнения операций с использованием
            банковских карт и криптовалют.
          </Typography>
          <Typography paragraph>
            1.3. Для использования платформы Пользователь обязан соблюдать все
            требования, указанные в настоящем Соглашении.
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. Пополнение депозита
          </Typography>
          <Typography paragraph>
            2.1. Пользователь может пополнить свой баланс исключительно через
            криптовалюту <strong>USDT-TRC20</strong>. Курс конвертации USDT-RUB
            определяется автоматически на момент создания заявки на пополнение.
          </Typography>
          <Typography paragraph>
            2.2. Платформа не несет ответственности за ошибки, допущенные
            Пользователем при переводе средств (например, неверный адрес
            кошелька). Возврат средств в таких случаях невозможен.
          </Typography>

          <Typography paragraph>
            3.2. <strong>Получение средств:</strong>
          </Typography>
          <Box component="ul" sx={{ pl: 4 }}>
            <Typography component="li" paragraph>
              Пользователь соглашается с тем, что для получения заявок на
              перевод средств необходимо поддерживать достаточный страховой
              баланс. При отсутствии необходимого страхового баланса
              Пользователь не сможет принимать заявки.
            </Typography>
            <Typography component="li" paragraph>
              Пользователь принимает условие, что при получении заявки на
              получение средств система автоматически замораживает часть
              страхового баланса на сумму заявки. Заморозка действует до момента
              подтверждения получения средств Пользователем или до подтверждения
              системой факта отсутствия перевода.
            </Typography>
            <Typography component="li" paragraph>
              Пользователь обязуется подтвердить поступление средств на свою
              банковскую карту в течение срока, указанного в заявке.
            </Typography>
          </Box>

          <Typography paragraph>
            3.3. <strong>Перевод средств:</strong>
          </Typography>
          <Box component="ul" sx={{ pl: 4 }}>
            <Typography component="li" paragraph>
              Пользователь обязуется выполнить перевод средств на банковскую
              карту другого участника системы в течение срока, указанного в
              заявке.
            </Typography>
            <Typography component="li" paragraph>
              Пользователь соглашается с тем, что после подтверждения отправки
              средств система автоматически спишет сумму с основного баланса.
              Пользователь несет ответственность за наличие достаточных средств
              на основном балансе для выполнения операции.
            </Typography>
            <Typography component="li" paragraph>
              Пользователь принимает на себя полную ответственность за
              корректность выполнения перевода, включая правильность указанных
              реквизитов получателя. Платформа не несет ответственности за
              ошибки, допущенные Пользователем при выполнении перевода.
            </Typography>
          </Box>

          <Typography variant="h6" gutterBottom>
            4. Требования к реквизитам
          </Typography>
          <Typography paragraph>
            4.1. Пользователь обязуется добавлять только проверенные и
            принадлежащие ему реквизиты банковских карт. Все предоставленные
            реквизиты проходят модерацию, и их использование должно
            соответствовать законодательству вашей страны.
          </Typography>
          <Typography paragraph>
            4.2. Платформа оставляет за собой право отклонять заявки на
            добавление реквизитов, если они не соответствуют установленным
            требованиям.
          </Typography>

          <Typography variant="h6" gutterBottom>
            5. Ответственность сторон
          </Typography>
          <Typography paragraph>
            5.1. Пользователь несет полную ответственность за все действия,
            совершенные с использованием его аккаунта, включая финансовые
            операции.
          </Typography>
          <Typography paragraph>
            5.2. Платформа не несет ответственности за любые убытки, возникшие в
            результате:
          </Typography>
          <Box component="ul" sx={{ pl: 4 }}>
            <Typography component="li" paragraph>
              Неправильного использования платформы Пользователем;
            </Typography>
            <Typography component="li" paragraph>
              Несвоевременного подтверждения операций;
            </Typography>
            <Typography component="li" paragraph>
              Предоставления недостоверных данных или реквизитов.
            </Typography>
          </Box>
          <Typography paragraph>
            5.3. Платформа оставляет за собой право приостановить или
            заблокировать аккаунт Пользователя в случае нарушения условий
            настоящего Соглашения, а также при наличии подозрений на
            мошеннические действия.
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. Конфиденциальность
          </Typography>
          <Typography paragraph>
            6.1. Платформа обязуется обеспечивать защиту персональных данных
            Пользователя в соответствии с политикой конфиденциальности.
          </Typography>
          <Typography paragraph>
            6.2. Пользователь соглашается на обработку его персональных данных
            для целей функционирования платформы, включая проверку реквизитов и
            отправку уведомлений.
          </Typography>

          <Typography variant="h6" gutterBottom>
            7. Изменение условий Соглашения
          </Typography>
          <Typography paragraph>
            7.1. Платформа оставляет за собой право вносить изменения в
            настоящее Соглашение без предварительного уведомления Пользователя.
          </Typography>
          <Typography paragraph>
            7.2. Все изменения вступают в силу с момента их публикации на сайте
            платформы. Продолжение использования платформы после внесения
            изменений означает согласие Пользователя с новыми условиями.
          </Typography>

          <Typography variant="h6" gutterBottom>
            8. Прекращение работы с платформой
          </Typography>
          <Typography paragraph>
            8.1. Пользователь имеет право прекратить использование платформы в
            любой момент, направив соответствующий запрос в службу поддержки.
          </Typography>
          <Typography paragraph>
            8.2. Платформа оставляет за собой право прекратить доступ
            Пользователя к платформе в случае нарушения условий Соглашения или
            при наличии других веских оснований.
          </Typography>

          <Typography variant="h6" gutterBottom>
            9. Заключительные положения
          </Typography>
          <Typography paragraph>
            9.1. Настоящее Соглашение является юридически обязывающим договором
            между Платформой и Пользователем.
          </Typography>
          <Typography paragraph>
            9.2. Все споры, возникающие в связи с использованием платформы,
            разрешаются в соответствии с действующим законодательством страны,
            на территории которой зарегистрирована Платформа.
          </Typography>
          <Typography paragraph>
            9.3. Если у вас возникли вопросы по поводу настоящего Соглашения,
            пожалуйста, свяжитесь со службой поддержки через контактные данные,
            указанные на сайте платформы.
          </Typography>

          <Typography variant="h6" gutterBottom>
            Заключение
          </Typography>
          <Typography paragraph>
            <strong>
              Принимая условия данного Соглашения, вы подтверждаете, что
              ознакомились с его содержанием и согласны соблюдать все правила и
              требования платформы Pay2Pay.org.
            </strong>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export { AgreementPage };
